import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { INVERTER_APP_LIST } from 'utils/inverterApps';

import { Field, Notice, SmallAction } from './setup-wizard.styles';

/**
 * "Onde encontro esse número?" — ajuda da geração manual do plano Free (F2 do
 * assistente, out/2026). Passo a passo em texto por app de inversor (os prints
 * entram quando forem tirados de contas reais) e o lembrete de que nos planos
 * pagos a geração entra sozinha.
 */
export const ManualGenerationHelp = ({
  onNavigate,
}: {
  onNavigate?: () => void;
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [slug, setSlug] = useState(INVERTER_APP_LIST[0].slug);
  const app =
    INVERTER_APP_LIST.find((a) => a.slug === slug) ?? INVERTER_APP_LIST[0];

  return (
    <div style={{ textAlign: 'left' }}>
      <SmallAction type="button" onClick={() => setOpen((v) => !v)}>
        {open ? 'Fechar ajuda' : 'Onde encontro esse número?'}
      </SmallAction>
      {open && (
        <Notice tone="info">
          <Field>
            App do seu inversor
            <select value={slug} onChange={(e) => setSlug(e.target.value)}>
              {INVERTER_APP_LIST.map((a) => (
                <option key={a.slug} value={a.slug}>
                  {a.app} ({a.brand})
                </option>
              ))}
            </select>
          </Field>
          <ol style={{ margin: 0, paddingLeft: 20 }}>
            {app.where.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </Notice>
      )}
      <p style={{ fontSize: 13, marginTop: 8, textAlign: 'left' }}>
        Nos planos pagos, a geração entra sozinha pela conexão com o inversor.{' '}
        <SmallAction
          type="button"
          onClick={() => {
            onNavigate?.();
            navigate('/conta');
          }}
        >
          Ver planos
        </SmallAction>
      </p>
    </div>
  );
};
